var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-5",attrs:{"color":"secondary","small":"","outlined":""},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v("STOP")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }